import { AvField } from "availity-reactstrap-validation"
import { Link } from "react-router-dom"
import { Row, Col, Card, CardBody, Alert, FormGroup, Label } from "reactstrap"
import { useEffect, useState } from "react"
import ApplicationService from "services/applications/Application.service"
import ViewAttachments from "components/Application/ViewAttachments"
import EnvAuditService from "services/applications/envAudit/EnvAuditService"
import OfficerChecklistReviewForm from "pages/Application/EnvironmentalAudit/OfficerChecklistReviewForm"
import TinyMCEEditor from "components/RichTextEditor/TinyMCEEditor"

let appService = null

const envAuditService = new EnvAuditService(
  JSON.parse(localStorage.getItem("authUser"))
)

const DirectorFormEnvAudit = props => {
  const BASE_URL = process.env.REACT_APP_BASE_URL
  const [showCertificatePreview, setshowCertificatePreview] = useState(false)
  const certPreviewUrl =
  BASE_URL + "verify/certificate/" + props.appDetails.app_id + "?preview=true"

  const torPreviewUrl =
    BASE_URL + "verify/tor/" + props.appDetails.app_id + "?preview=true"
  const finalTorUrl = BASE_URL + "verify/tor/" + props.appDetails.app_id

  const [signedCertificate, setsignedCertificate] = useState(null)
  const [manualProcessing, setmanualProcessing] = useState(false)
  const [applicationPhase, setapplicationPhase] = useState("phase 1")
  const [termsOfReferenceFinal, setTermsOfReferenceFinal] = useState(null)
  const [staffUploads, setstaffUploads] = useState([])

  // checklist review
  const [checklistFormData, setchecklistFormData] = useState({})
  const [questions, setQuestions] = useState([])
  const [existingChecklists, setexistingChecklists] = useState([])
  const [mountChecklists, setmountChecklists] = useState(false)

  // RichText
  const [approvalConditions, setapprovalConditions] = useState("")
  const [mountRichText, setmountRichText] = useState(false)
  const [mountToR, setmountToR] = useState(false)
  const [applicationToR, setapplicationToR] = useState("")

  const [showDraftToRPreview, setshowDraftToRPreview] = useState(false)


  useEffect(() => {
    const userObj = JSON.parse(localStorage.getItem("authUser"))
    appService = new ApplicationService(userObj)
    // console.log("app details -> ", props.appDetails)
    if (props.appDetails.is_application_in_phase_2) {
      setapplicationPhase("phase 2")
    }
    if (props.appDetails.approval_conditions != null) {
      // console.log("conditions --->", props.appDetails.approval_conditions)
      setapprovalConditions(props.appDetails.approval_conditions)
    }
    if (props.appDetails.application_tor != null) {
      setapplicationToR(props.appDetails.application_tor)
    }
    setmountToR(true)

    setmountRichText(true)
    getApplicationAttachments()
    fetchReviewQuestions()
    fetchApplicationCheckList()
  }, [])

  const fetchReviewQuestions = () => {
    envAuditService.getAllChecklistQuestions().then(response => {
      //   console.log("questions -----> ", response);
      if (response.status) {
        setQuestions(response.data)
      }
    })
  }

  const fetchApplicationCheckList = () => {
    envAuditService
      .getApplicationChecklist(props.appDetails.id)
      .then(response => {
        // console.log("application checklist ", response)
        if (response.status) {
          setexistingChecklists(response.data)
          setmountChecklists(true)
        }
      })
  }

  const getApplicationAttachments = () => {
    const descriptions = [
      "Draft_Terms_of_Reference",
      "Checklist_Review_Document",
      "Inspection Report",
    ]
    const atts = props.appDetails.application_attachments.filter(attachment =>
      descriptions.includes(attachment.description)
    )
    setstaffUploads(atts)
  }

  const decisionValueChange = value => {
    // show certificate preview for Auth plastics
    if (props.appDetails.service_id == 1) {
      if (value == "006") {
        setshowCertificatePreview(true)
      } else {
        setshowCertificatePreview(false)
      }
    }

     if (value == "018") {
      setshowDraftToRPreview(true)
    } else {
      setshowDraftToRPreview(false)
    }
  }

  const handleDocumentChange = e => {
    if (e.target.files.length > 0) {
      setsignedCertificate(e.target.files[0])
    }
  }

  async function uploadCertificate(e) {
    if (props.appDetails.manually_processed) {
      // e.preventDefault()
      if (signedCertificate == null) {
        e.preventDefault()
        alert("Please select signed certificate!")
        return
      }

      const certificate = {
        file: signedCertificate,
        application_id: props.appDetails.id,
        description: "manual_certificate",
      }

      const response = await appService.uploadSignedManualCertificate(
        certificate
      )

      if (response.status) {
        // setdisableButton(false)
        // setShowSuccessAlert(true)
      } else {
        alert("Error uploading signed certificate. Please try again.")
      }
    }

    // upload final Terms of Reference
    if (applicationPhase == "phase 1") {
      // uploadFinalTermsOfReference()
    }

    if (applicationPhase == "phase 2") {
      submitCheckListReview()
    }
  }

  const handleFileChange = (event, setFile) => {
    const file = event.target.files[0]
    setFile(file)
  }

  async function uploadFinalTermsOfReference() {
    // Final Terms of Reference
    if (termsOfReferenceFinal) {
      const termsReport = {
        file: termsOfReferenceFinal,
        application_id: props.appDetails.id,
        description: "Final_Terms_of_Reference",
      }

      await appService.uploadFile(termsReport)
    }
  }

  const handleCheckListChange = formData => {
    // console.log("checklist form data ", {name: name, value: value})
    setchecklistFormData(formData)
    // console.log("checklistFormData --> ", checklistFormData)
  }

  const submitCheckListReview = () => {
    console.log("form data --> ", checklistFormData)
    const responses = questions.map(question => {
      const isCompliant = checklistFormData[`question-${question.id}`] === "Yes"
      const officerNotes = checklistFormData[`notes-${question.id}`] || ""

      return {
        application_id: props.appDetails.id,
        check_list_question_id: question.id,
        is_compliant: isCompliant,
        officer_notes: officerNotes,
      }
    })

    const submitData = {
      application_id: props.appDetails.id,
      data: responses,
    }

    // console.log("Form Responses:", responses);

    envAuditService.createApplicationChecklist(submitData).then(response => {
      console.log("submitted checklist review ", response)
    })
  }

  // RichText
  const handleEditorChange = content => {
    // console.log("HTML Content:", content)
    setapprovalConditions(content)
  }

  const handleToREditorChange = content => {
    // console.log("DG Content:", content)
    setapplicationToR(content)
  }

  // saveDraftTermsOfReference
  const saveDraftTermsOfReference = draftTor => {
    const data = {
      application_id: props.appDetails.id,
      application_tor: draftTor,
    }
    envAuditService.updateTermsOfReference(data).then(response => {
      // console.log("response save draft ToR", response)
    })
  }

  return (
    <>
      <Row>
        <Col lg="12">
          <Card>
            <CardBody>
              <div>
                <AvField
                  type="hidden"
                  name="application_id"
                  value={props.appDetails.id}
                />

                <AvField
                  type="hidden"
                  name="approval_conditions"
                  value={approvalConditions}
                />

                <AvField
                  type="hidden"
                  name="application_tor"
                  value={applicationToR}
                />
              </div>

              <div>
                {props.error && props.error == true ? (
                  <Row className="alert alert-danger">
                    <Col md="12">{props.message}</Col>
                  </Row>
                ) : null}

                {props.success && props.success == true ? (
                  <Row className="alert alert-success">
                    <Col md="8">{props.message}</Col>
                    <Col md="4">
                      <Link to="/dashboard" style={{ float: "right" }}>
                        Back
                      </Link>
                    </Col>
                  </Row>
                ) : null}
              </div>

              {applicationPhase == "phase 2" ? (
                <Alert color="info">
                  Applicant has uploaded additional documents. Please check them
                  in the <b>Appplication Details</b> below
                </Alert>
              ) : null}

              <div className="mb-3">
                <AvField
                  type="select"
                  name="decision_code"
                  label="Select Decision"
                  onChange={v => {
                    decisionValueChange(v.target.value)
                  }}
                  disabled={props.success}
                  required
                >
                  <option value="">--select Decision--</option>
                  {applicationPhase == "phase 1" ? (
                    <option value="018">Terms of Reference - Approve</option>
                  ) : (
                    <option value="006">Approve</option>
                  )}
                  <option value="008">Send Back</option>
                  <option value="009">Reject</option>
                </AvField>
              </div>

              <Row className="mb-3">
                <label
                  htmlFor="txtAddress1Billing"
                  className="col-lg-3 col-form-label"
                >
                  Reason
                </label>
                <div className="col-lg-9">
                  <AvField
                    type="textarea"
                    name="reason"
                    rows="2"
                    required
                    className="form-control"
                  ></AvField>
                </div>
              </Row>
              {applicationPhase == "phase 1" ? (
                <FormGroup>
                  {/* <br></br>
                  <Label for="termsOfReferenceFinal">
                    Final Terms of Reference
                  </Label>
                  <br></br>
                  <AvField
                    className="btn"
                    type="file"
                    name="termsOfReferenceFinal"
                    id="termsOfReferenceFinal"
                    accept=".pdf,.doc,.docx"
                    onChange={e =>
                      handleFileChange(e, setTermsOfReferenceFinal)
                    }
                    required={true}
                  /> */}
                </FormGroup>
              ) : null}

              {showCertificatePreview ? (
                <Row className="mb-3">
                  <Alert color="info">
                    Before submitting your review, please click on the preview
                    link below to see how the certificate will display after the
                    approval processes.
                  </Alert>
                  <a className="linkItem" target="_blank" href={certPreviewUrl}>
                    Preview Certificate{" "}
                    <i
                      className="fa fa-certificate"
                      title="Preview Certificate"
                    ></i>
                  </a>
                </Row>
              ) : null}

              {/* show ToR Preview */}
              {applicationPhase == "phase 1" ? (
                <>
                {showDraftToRPreview ? (
                    <Row className="mb-3">
                      <Alert color="info">
                        Before submitting your review, please click on the
                        preview link below to see how the ToR draft will display
                        after the approval processes.
                      </Alert>
                      <a
                        className="linkItem"
                        target="_blank"
                        href={torPreviewUrl}
                      >
                        Preview ToR{" "}
                        <i
                          className="fa fa-certificate"
                          title="Preview Draft ToR"
                        ></i>
                      </a>
                    </Row>
                  ) : null}
                </>
                // <Row className="mb-3">
                //   <Alert color="info">
                //     Before submitting your review, please click on the preview
                //     link below to see how the ToR certificate will display after
                //     the approval processes.
                //   </Alert>
                //   <a className="linkItem" target="_blank" href={torPreviewUrl}>
                //     Preview ToR{" "}
                //     <i
                //       className="fa fa-certificate"
                //       title="Preview Certificate"
                //     ></i>
                //   </a>
                // </Row>
              ) : (
                
                <Row className="mb-3">
                  <Alert color="info">
                    Click below to view final ToR Certificate.
                  </Alert>
                  <a className="linkItem" target="_blank" href={finalTorUrl}>
                    Final Terms of Reference{" "}
                    <i
                      className="fa fa-certificate"
                      title="ToR Certificate"
                    ></i>
                  </a>
                </Row>
              )}

              {mountToR &&
              props.appDetails.decision == "PROPOSE_FOR_TOR_ACQUISTION" ? (
                <TinyMCEEditor
                  label="Draft Terms of Reference"
                  value={applicationToR}
                  onChange={handleToREditorChange}
                  onBlur={saveDraftTermsOfReference}
                />
              ) : null}

              {mountChecklists && applicationPhase == "phase 2" ? (
                <OfficerChecklistReviewForm
                  existingChecklists={existingChecklists}
                  handleChange={handleCheckListChange}
                  isReadOnly={true}
                />
              ) : null}
              {/* <a href="#" onClick={submitCheckListReview}>Test Submit CheckList</a> */}

              <div>
                <hr></hr>
                <label>Inspection Documents uploaded by officer</label>
                <ViewAttachments attachments={staffUploads} />
              </div>

              {/* {props.appDetails.manually_processed ? (
                <>
                  {" "}
                  <Alert color="info">
                    Because this application is marked as archived, you are to
                    upload the signed certificate using the file upload button
                    below.
                  </Alert>
                  <input
                    className="form form-control"
                    type="file"
                    name="final_manual_certificate"
                    accept=".pdf,image/*,.doc,.docx"
                    onChange={handleDocumentChange}
                    required
                  />
                </>
              ) : null} */}

              {/* RichText */}
              <div>
                {mountRichText && applicationPhase === "phase 2" ? (
                  <TinyMCEEditor
                    value={approvalConditions}
                    onChange={handleEditorChange}
                  />
                ) : null}
                {/* <h4>Preview:</h4>
                <div dangerouslySetInnerHTML={{ __html: editorContent }} /> */}
              </div>

              {props.loading && props.loading === true ? (
                <Link
                  to="#"
                  className="spinner-border text-info"
                  style={{ float: "right" }}
                />
              ) : (
                <div className="mt-5">
                  <button
                    className="btn btn-lg btn-primary col-12"
                    disabled={props.success}
                    onClick={uploadCertificate}
                  >
                    Submit Review
                  </button>
                </div>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </>
  )
}

export default DirectorFormEnvAudit
